import {
  DialogActions,
  Divider,
  FormControl,
  Grid,
  Icon,
  Typography,
} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Fab from "@material-ui/core/Fab";
import { withStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import Add from "@material-ui/icons/Add";
import CloudUpload from "@material-ui/icons/CloudUpload";
import axios from "axios";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import { connect } from "react-redux";

import * as cookie from "../../helper/cookie";
import { mapActionsToProps } from "../../redux/cloudPBX/sound";
import Dialog from "./../../components/Dialog";
import TableData from "./../../components/TableData";
import datetimeHelper from "./../../helper/datetime-helper";
import { globalHistory } from "./../../history";

const API_PROTOCOL = process.env.REACT_APP_API_PROTOCOL || "";
const API_HOST = process.env.REACT_APP_API_HOST || "";
const API_PATH = process.env.REACT_APP_API_PATH || "";

const basicUrl = `${process.env.REACT_APP_API_PROTOCOL}://${process.env.REACT_APP_API_HOST}/media-mgt/container/ivrs/download/`;

const styles = (theme) => ({
  model: {
    width: "100%",
  },
  card: {
    maxWidth: "100%",
  },
  form: {
    width: "100%",
  },
  input: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
  },
  chip: {
    margin: theme.spacing.unit,
  },
  fab: {
    margin: theme.spacing.unit * 3,
    whiteSpace: "nowrap",
  },
  bulletOffline: {
    display: "inline-block",
    margin: "0 2px",
    transform: "scale(1.8)",
    color: "red",
  },
  bulletOnline: {
    display: "inline-block",
    margin: "0 2px",
    transform: "scale(1.8)",
    color: "chartreuse",
  },
});

class Sound extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      note: "",
      length: 0,
      data: [],
      modalSend: false,
      filters: {
        order: "createdAt DESC",
        where: {
          gte: null,
          lte: null,
        },
        page: 0,
        pageSize: 20,
      },
      item: {},
      modalEdit: false,
      modalDelete: false,
      showpassword: false,
      modalAction: false,
      error: false,
      token: "",
    };
  }
  componentDidMount() {
    this.itemInit();
    this.history = globalHistory();
    this.props.getListSound();
    this.setState({ token: cookie.getCookie("access_token") });
  }

  listCollumns = [
    { id: "name", numeric: true, disablePadding: false, label: "Tên" },
    { id: "fileName", numeric: true, disablePadding: false, label: "Tên file" },
    {
      id: "createdAt",
      numeric: true,
      disablePadding: false,
      label: "Thời gian tạo",
    },
    { id: "note", numeric: true, disablePadding: false, label: "Ghi chú" },
    { id: "action", numeric: true, disablePadding: false, label: "Hành động" },
  ];

  itemInit() {
    const where = {};
    const and = [];
    const { filters } = this.state;
    for (const key in filters.where) {
      if (filters.where.hasOwnProperty(key)) {
        const element = filters.where[key];
        if (element) {
          switch (key) {
            case "name":
            case "status":
            default: {
              if (key.startsWith("from") || key.startsWith("to")) {
                if (key == "from") {
                  and.push({ time: { gte: this.state.filters.where.from } });
                  where.and = and;
                } else {
                  and.push({ time: { lte: this.state.filters.where.to } });
                  where.and = and;
                }
              } else {
                where[key] = element;
              }
              break;
            }
          }
        }
      }
    }
    this.props.getListSound(filters.order, filters.pageSize, filters.page, {
      where,
    });
    this.props.countListSound({ where });
  }

  openDialogCreate = () => {
    this.setState({ modalSend: !this.state.modalSend });
  };

  handleClose = () => {
    this.setState({
      modalSend: false,
      modalAction: false,
      modalDelete: false,
      item: {},
      fileName: "",
      error: false,
    });
  };

  openModalEdit = (item) => {
    this.state.item = item;
    this.setState({ modalAction: true, fileName: "", error: false });
  };

  openModalDelete = (item) => {
    this.state.item = item;
    this.setState({ modalDelete: true });
  };

  handleChangePage = (e, page) => {
    const { filters } = this.state;
    this.setState({ page });
    filters.page = page * filters.pageSize;
    this.itemInit();
  };

  handleChangeRowsPerPage = (e) => {
    const { filters } = this.state;
    filters.pageSize = e.target.value;
    this.setState(
      {
        filters,
      },
      () => {
        this.itemInit();
      }
    );
  };

  handleSearch = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    const { filters } = this.state;
    filters.where[name] = value;
    this.setState({
      filters,
    });
  };
  handleSubmit = (e) => {
    const { filters } = this.state;
    filters.skip = 0;
    this.setState(
      {
        disable: false,
        filters: {
          ...filters,
          page: 0,
        },
      },
      () => {
        setTimeout(() => {
          this.itemInit();
        }, 1000);
      }
    );
  };

  handleDateChangeStart = (from) => {
    const { filters } = this.state;
    filters.where.from = datetimeHelper.toFormat(from, "YYYY-MM-DD HH:mm:ss");
    this.setState({ from });
  };

  handleDateChangeEnd = (to) => {
    const { filters } = this.state;
    filters.where.to = datetimeHelper.toFormat(to, "YYYY-MM-DD HH:mm:ss");
    this.setState({ to });
  };

  handleChangeText = (name) => {
    return (e) => {
      this.setState({
        [name]: e.target.value,
      });
    };
  };

  handleChangeTextEdit = (name) => {
    return (e) => {
      this.setState({
        item: {
          ...this.state.item,
          [name]: e.target.value,
        },
      });
    };
  };

  handleCreateModel = () => {
    this.setState({
      modalAction: true,
      item: {},
      fileName: null,
      name: "",
      note: "",
      error: false,
    });
  };

  handleAction = () => {
    const { id } = this.state.item;
    if (!id) {
      const { name, note } = this.state;
      if (this.state.fileName) {
        return (
          this.props.addSound(name, this.state.fileName, note),
          setTimeout(
            function () {
              this.setState({
                modalAction: false,
                name: "",
                note: "",
                fileName: "",
              });
              this.itemInit();
            }.bind(this),
            500
          )
        );
      } else {
        this.setState({ error: true });
      }
    } else {
      const { id, name, note } = this.state.item;
      return (
        this.props.editSound(
          id,
          name,
          this.state.fileName ? this.state.fileName : this.state.item.fileName,
          note
        ),
        setTimeout(
          function () {
            this.setState({
              modalAction: false,
              name: "",
              note: "",
              fileName: null,
            });
            this.itemInit();
          }.bind(this),
          500
        )
      );
    }
  };

  handleDelete = () => {
    this.props.deleteSound(this.state.item.id);
    setTimeout(
      function () {
        this.setState({ modalDelete: false });
        this.itemInit();
      }.bind(this),
      500
    );
  };

  handleDateChangeFrom = (date) => {
    this.setState({ startAt: datetimeHelper.toFormat(date, "YYYY-MM-DD") });
  };

  handleDateChangeTo = (date) => {
    this.setState({ endAt: datetimeHelper.toFormat(date, "YYYY-MM-DD") });
  };

  handleClickShowpassword = () => {
    this.setState((state) => ({ showpassword: !state.showpassword }));
  };

  upload = (e) => {
    const data = new FormData();
    data.append("file", e.target.files[0]);
    axios
      .post(
        `${API_PROTOCOL}://${API_HOST}/${API_PATH}media-mgt/container/ivrs/upload`,
        data,
        {
          headers: {
            Authorization: this.state.token,
            "Content-Type": "multipart/form-data",
          },
        }
      )
      .then((res) => {
        this.setState({
          fileName: res.data.result.files.file[0].name,
          error: false,
        });
      })
      .catch(() =>
        this.setState({
          fileName: "",
          error: this.state.item ? !this.state.item.id : true,
        })
      );
  };

  render() {
    const { classes, listSound, coutSound } = this.props;
    const {
      id,
      name,
      filters,
      note,
      item,
      modalDelete,
      modalAction,
      password,
      status,
    } = this.state;
    return (
      <React.Fragment>
        <TableData
          {...this.props}
          nameTable="Danh sách lời chào"
          items={listSound}
          rowsPerPage={filters.pageSize}
          count={this.props.count ? this.props.count.count : 0}
          page={
            filters.pageSize === 20
              ? filters.page / 20
              : filters.pageSize === 40
              ? filters.page / 40
              : filters.pageSize === 60
              ? filters.page / 60
              : filters.pageSize === 80
              ? filters.page / 80
              : filters.page / 100
          }
          rowItems={this.listCollumns}
          allowCreate={true}
          handleEdit={this.openModalEdit}
          handleDelete={this.openModalDelete}
          handleChangePage={this.handleChangePage}
          handleChangeRowsPerPage={this.handleChangeRowsPerPage}
          createAction={
            <Tooltip title="Thêm mới" disableFocusListener>
              <Fab
                color="primary"
                aria-label="add"
                className={classes.fab}
                size="small"
                onClick={this.handleCreateModel}>
                <Add className={classes.add} />
              </Fab>
            </Tooltip>
          }
        />
        <Dialog
          open={this.state.modalAction}
          title={
            item
              ? item.id
                ? "Chỉnh sửa thông tin file âm thanh"
                : "Thêm file âm thanh"
              : null
          }
          input={
            <ValidatorForm
              ref="form"
              onSubmit={this.handleAction}
              onError={(errors) => console.log(errors)}
              className={classes.form}>
              <FormControl className={classes.form}>
                <Grid container className={classes.grid}>
                  <TextValidator
                    id="outlined-full-width"
                    margin="normal"
                    label="Tên lời chào"
                    variant="outlined"
                    autoFocus={true}
                    className={classes.input}
                    onChange={
                      item
                        ? item.id
                          ? this.handleChangeTextEdit("name")
                          : this.handleChangeText("name")
                        : null
                    }
                    value={item ? (item.id ? item.name : name) : null}
                    name="name"
                    validators={["required"]}
                    errorMessages="Không được để trống"
                  />
                  {/*<div style={{ color: "#fff", display: "flex", alignItems: "center", paddingTop: 10, paddingBottom: 10 }} >*/}
                  {/*    <Typography style={{ marginRight: 5 }}>Upload lời chào</Typography><br/>*/}
                  {/*    <CloudUpload />*/}
                  {/*    /!*<div style={{ color: 'black', fontFamily: 'Roboto', fontSize: '14px' }}>{this.props.file ? this.props.file.result.files.file[0].name : ''}</div>*!/*/}
                  {/*    <input type="file" name="fileName" id="fileName" style={{ marginLeft: 15 }} onChange={this.upload}/>*/}
                  {/*</div>*/}
                  {(Object.keys(this.state.item).length ||
                    this.state.fileName) && (
                    <audio
                      ref="audio"
                      src={basicUrl.concat(
                        this.state.fileName
                          ? this.state.fileName
                          : this.state.item.fileName
                      )}
                      controls
                      autoPlay={false}
                    />
                  )}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      paddingTop: 10,
                      paddingBottom: 10,
                    }}>
                    <Typography style={{ marginRight: 5 }}>
                      Upload lời chào
                    </Typography>
                    <CloudUpload />
                    <input
                      type="file"
                      name="fileName"
                      id="fileName"
                      style={{ marginLeft: 15 }}
                      onChange={this.upload}
                    />
                  </div>
                  {this.state.error && (
                    <p className="error-messages">
                      Vui lòng chọn file âm thanh
                    </p>
                  )}
                  <TextValidator
                    id="outlined-full-width"
                    margin="normal"
                    label="Ghi chú"
                    variant="outlined"
                    className={classes.input}
                    onChange={
                      item
                        ? item.id
                          ? this.handleChangeTextEdit("note")
                          : this.handleChangeText("note")
                        : null
                    }
                    value={item ? (item.id ? item.note : note) : null}
                    name="note"
                  />
                </Grid>
                {item ? (
                  item.id ? (
                    <React.Fragment>
                      <Divider />
                      {item.contacts
                        ? item.contacts.map((contact) => {
                            return (
                              <div
                                style={{
                                  color: "#fff",
                                  display: "flex",
                                  alignItems: "center",
                                  paddingTop: 10,
                                  marginLeft: 15,
                                }}>
                                <Icon>person</Icon>
                                <Typography style={{ marginLeft: 10 }}>
                                  {contact.fullName} - {contact.phoneNumber}
                                </Typography>
                              </div>
                            );
                          })
                        : null}
                    </React.Fragment>
                  ) : (
                    ""
                  )
                ) : (
                  ""
                )}

                <DialogActions>
                  <Button
                    onClick={this.handleClose}
                    color="secondary"
                    className={classes.button}>
                    Hủy
                  </Button>
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    className={classes.button}>
                    Lưu
                  </Button>
                </DialogActions>
              </FormControl>
            </ValidatorForm>
          }
          onClose={this.handleClose}
        />
        <Dialog
          open={modalDelete}
          title={`Bạn có muốn xóa?`}
          button={true}
          onSubmit={this.handleDelete}
          onClose={this.handleClose}
        />
      </React.Fragment>
    );
  }
}

Sound.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  listSound: state.sound.sounds,
  count: state.sound.count,
  file: state.sound.file,
});

Sound = connect(mapStateToProps, mapActionsToProps)(Sound);

export default withStyles(styles)(Sound);
